module.exports = __webpack_public_path__ + "img/meter-droplet.fc455b54.svg";